module.exports = __webpack_public_path__ + "img/rotterdam3.89ada3b7.jpg";